import styled from 'styled-components';

import { InputProps } from 'app/shared/typings/input';
import { withTextfieldStyle } from 'app/shared/components/styleUtils/manualCSS/withTextfieldStyle';

export const Textfield = styled.input<InputProps>`
  ${withTextfieldStyle};
`;
